const bytesToUuid = (bytes) => {
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));
    return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`;
};

export const createCommunicationRequestId = () => {
    const browserCrypto = typeof window !== 'undefined' ? window.crypto : null;
    if (typeof browserCrypto?.randomUUID === 'function') {
        return browserCrypto.randomUUID();
    }

    const bytes = new Uint8Array(16);
    if (typeof browserCrypto?.getRandomValues === 'function') {
        browserCrypto.getRandomValues(bytes);
    } else {
        for (let index = 0; index < bytes.length; index += 1) {
            bytes[index] = Math.floor(Math.random() * 256);
        }
    }

    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    return bytesToUuid(bytes);
};

export const SMS_CONFIRMATION_PENDING_MESSAGE = 'Text submitted. CaseDB is checking delivery. It was not sent again.';

export const isSmsConfirmationPending = (result) => (
    result?.success === true && result?.pending_confirmation === true
);

export default createCommunicationRequestId;
